export const environment = {
	production: false,
	name: 'development',
	apiUrl: 'https://api.dev.la-recolte.net',
	scanningDelay: 5000,
};
